import React from 'react';
import { Link } from 'react-router-dom';
import './PromoTile.css';

// Single promo band (the partners tile from the reference is intentionally
// dropped). Static brand value-prop with a CTA into the sets catalog.
const PromoTile = () => (
    <section className="gh-promo">
        <div className="gh-promo-tile">
            <div className="gh-promo-copy">
                <p className="gh-promo-eyebrow">Why Gradies</p>
                <h3 className="gh-promo-title">Find your favorite.</h3>
                <p className="gh-promo-sub">
                    Every listing is an official PSA graded Pokémon card. Search by evolutionary line, type, or Pokémon name.
                </p>
                <Link to="/sets" className="gh-promo-cta">Browse sets</Link>
            </div>
        </div>
    </section>
);

export default PromoTile;
